<template lang="pug">
  v-btn.done-btn(color="#1B93AD" fixed right bottom) 
    slot
</template>

<script>
export default {
  name: "button-back-page"
}
</script>

<style scoped>
  .done-btn {
    right: 40%;
    bottom: 25px;
  }
</style>